






import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';
import storage from '@/services/local-storage.service'
import {Action, State} from "vuex-class";
import {getStyleSheet} from "@/utils/StyleSheet";

@Component({})
export default class App extends Vue {
    @State loggedUser!: string;
    @Action preloadData!: () => void;

    async created() {
        this.$i18n.locale = <string>storage.get('language') || 'rs';
        getStyleSheet();
    }

    @Watch('loggedUser') onUserLoggedIn() {
        this.preloadData();
    }
}
